import React from 'react';
import PropTypes from 'prop-types';
import exact from 'prop-types-exact';
import Top10PageContainer from './containers/Top10PageContainer';

const Top10App = ({ slug, withCategory }) => (<Top10PageContainer
    withCategory={withCategory}
    slug={slug}
/>);

Top10App.propTypes = exact({
    withCategory: PropTypes.bool,
    slug: PropTypes.string,
});

export default Top10App;
